export default __webpack_public_path__ + "static/media/Asset6_lrg.82656c1d.png";